module.exports = __webpack_public_path__ + "static/media/channel=failover.7f0b9587.svg";